import { HtmlRenderer, Parser } from 'commonmark'

export function simpleMarkdown(markdown: string): string {
  const parser = new Parser()
  const renderer = new HtmlRenderer()

  const parsed = parser.parse(markdown ?? '')
  return renderer.render(parsed)
}
